import slugify from "slugify";
import { FavoriteStorage, getGenericData, SearchedStorage } from "./local-storage-functions";
import LocalStorageHelper from "./local-storage-helper";
import geolocationInstructionsModal from "./geolocation-instructions-modal";

const Elements = {
  desktopAutocomplete: $('#desktopSearchAutocomplete'),
  mobileAutocomplete: $('#mobileSearchAutocomplete'),
  mobileSearchButton: $('#bt_modalSearch_mobile'),
  desktopInput: $('#searchGeneral'),
  mobileInput: $('#mobileSearchInput'),
  mobileUl: $('#mobileAutocompleteSuggestions'),
  desktopUl: $('#autocompleteSuggestions'),
  mobileHeader: $('#mobileAutocompleteHeader'),
  desktopHeader: $('#autocompleteHeader'),
  mobileEmptyMessage: $('#mobileAutocompleteEmptyHistory'),
  desktopEmptyMessage: $('#autocompleteEmptyHistory'),
  mobileClearButton: $('#mobileAutocompleteHeaderClearButton'),
  desktopClearButton: $('#autocompleteHeaderClearButton'),
  myLocationButton: $('#autocompleteSearchMyLocation'),
  mobileLocationButton: $('#mobileSearchAutocomplete #autocompleteSearchMyLocation'),
  desktopCloseButton: $('#desktopSearchAutocomplete .autocomplete-close'),
  mobileCloseButton: $('#mobileSearchAutocomplete .autocomplete-close'),

  getUl() { return this.getIsDesktop() ? this.desktopUl : this.mobileUl; },
  getHeader() { return this.getIsDesktop() ? this.desktopHeader : this.mobileHeader; },
  getEmptyMessage() { return this.getIsDesktop() ? this.desktopEmptyMessage : this.mobileEmptyMessage; },
  getClearButton() { return this.getIsDesktop() ? this.desktopClearButton : this.mobileClearButton; },
  getInput() { return this.getIsDesktop() ? this.desktopInput : this.mobileInput; },
  getAutocomplete() { return this.getIsDesktop() ? this.desktopAutocomplete : this.mobileAutocomplete; },
  getIsDesktop() { return $(window).outerWidth() > 1199; }
};

export const keyByType = { city: 'city', beach: 'beach', airport: 'airport' };
export const idKeyByType = { city: 'idcity', beach: 'idbeach', airport: 'idairport' };
export const pathByType = { city: 'cidade', beach: 'litoral', airport: 'aeroporto' };
export const titleByType = { city: 'Cidades', beach: 'Praias', airport: 'Aeroportos' };


let isAutocompleteInitialized = false;
let currentSuggestions = [];
let isDesktopView = Elements.getIsDesktop();

export function autocomplete() {
  if (isAutocompleteInitialized) return;
  isAutocompleteInitialized = true;

  resizeEventHandler();
  searchButtonEventHandler();
  setupInputListener();
  setupDesktopClickListener();
  setupClickOutsideListener();
  renderSearchHistory();
  setupUseLocationButtonListener();
  setupCloseButtons();
  setupClearHistoryButtonListener();
  setupFavoriteChangeListener();
  initializeMyLocationLabel();
  openSearchWhenComingFromPush();
}

function resizeEventHandler() {
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      const wasPreviouslyDesktop = isDesktopView;
      isDesktopView = Elements.getIsDesktop();

      if (wasPreviouslyDesktop !== isDesktopView) {
        Elements.desktopAutocomplete.hide();
        Elements.mobileAutocomplete.hide();
        Elements.mobileSearchButton.attr('aria-expanded', 'false');
        removeInputListeners();
        setupInputListener();
        setupDesktopClickListener();
        renderSearchHistory();
        setupUseLocationButtonListener();
      }
    }, 50);
  });
}

function searchButtonEventHandler() {
  const searchButton = Elements.mobileSearchButton;

  searchButton.on('click', () => {
    const wrapper = $('[data-id="mobile-search"]');
    if (wrapper.length) {
      Elements.mobileAutocomplete.css('display', 'flex');
      Elements.getInput().attr('aria-expanded', 'true').trigger('focus');
      searchButton.attr('aria-expanded', 'true');
      pushOnDataLayer('open_element', 'Menu_MainSearch');
      return;
    }
    const container = Elements.getAutocomplete();
    const isVisible = container.css('display') === 'flex';
    container.css('display', isVisible ? 'none' : 'flex');
    searchButton.attr('aria-expanded', isVisible ? 'false' : 'true');

    if (!isVisible) {
      Elements.getInput().attr('aria-expanded', 'true').trigger('focus')
      pushOnDataLayer('open_element', 'Menu_MainSearch');

      return
    }

    Elements.getInput().attr('aria-expanded', 'false');
    pushOnDataLayer('close_element', 'Menu_MainSearch');
  });
}

function setupInputListener() {
  const handler = createDebouncedInputHandler();
  Elements.desktopInput.on('input', handler);
  Elements.mobileInput.on('input', handler);
}

function removeInputListeners() {
  Elements.desktopInput.off('input click');
  Elements.mobileInput.off('input');
}

function createDebouncedInputHandler() {
  return debounce(async function () {
    const input = $(this).val()?.trim();
    const ul = Elements.getUl();
    const header = Elements.getHeader();
    const emptyMessage = Elements.getEmptyMessage();

    if (!input) {
      ul.hide().empty();
      emptyMessage.css('display', 'flex');
      header.css('display', 'flex');
      renderSearchHistory();
      return;
    }

    if (input.length < 3) return;

    try {
      const response = await $.ajax({
        url: '/json/busca-por-nome',
        type: "POST",
        dataType: "json",
        cache: true,
        data: { name: input }
      });

      treatResponse(response);
    } catch (error) {
      console.error("Erro na busca:", error);
    }
  }, 300);
}

function treatResponse(response) {
  const validTypes = ['city', 'beach', 'airport'];

  const sliced = response
    .map(({ response: { data }, type }) => {
      const normalizedType = type?.toLowerCase();
      return {
        places: Array.isArray(data) ? data.slice(0, 5) : [],
        type: normalizedType
      };
    })
    .filter(({ type }) => validTypes.includes(type));

  currentSuggestions = sliced;
  renderSuggestions(sliced);
}

function renderSearchHistory() {
  const history = SearchedStorage.get();
  const favorites = FavoriteStorage.get();
  const ul = Elements.getUl();
  const header = Elements.getHeader();
  const empty = Elements.getEmptyMessage();

  ul.empty();
  if (!history.length) {
    header.hide();
    empty.css('display', 'flex');
    ul.show();
    if (Array.isArray(favorites) && favorites.length) {
      appendFavoritesSection(ul, favorites);
    }
    return;
  }

  header.show();
  empty.hide();
  ul.show();

  let index = 0;

  history.reverse();

  history.forEach((raw) => {
    const isValidType = Object.keys(keyByType).some(type => raw?.[keyByType[type]]);
    const type = Object.keys(keyByType).find(type => raw?.[keyByType[type]]);

    if (!isValidType) return;

    index++;

    const place = LocalStorageHelper.unmapCityData(raw[type], type);
    const meta = buildCityMeta(place, keyByType[type]);
    const favButton = null;

    const li = createListItem({
      label: meta.label,
      href: meta.href,
      favButton,
      index,
      cityCid: raw[keyByType[type]].cid,
      isHistory: true
    });

    ul.append(li);
  });

  if (Array.isArray(favorites) && favorites.length) {
    appendFavoritesSection(ul, favorites, index);
  }
}

function appendFavoritesSection(ul, favorites, startIndex = 0) {
  ul.append($('<p>').text('Cidades favoritas'));

  let i = startIndex;

  const typeByPath = {
    'cidade': 'city',
    'litoral': 'beach',
    'aeroporto': 'airport'
  };

  favorites.forEach((fav) => {
    const city = fav?.city;
    if (!city) return;

    i++;
    const eventIndex = String(i).padStart(2, '0');

    const href = `/previsao-do-tempo/cidade/${city.slug}`;
    const label = city.label || '';
    const cid = city.cid;

    const firstSegment = String(city.slug || '').split('/')[0];
    const type = typeByPath[firstSegment] || 'city';

    const favButton = createFavoriteButton(city, type);

    const a = $('<a></a>')
      .attr('href', href)
      .attr('data-id', `Menu_MainSearch_FavoriteItem_NavLink-${eventIndex}`);

    const li = createListItem({
      label,
      href,
      favButton,
      linkElement: a,
      index: i,
      cityCid: cid,
      isHistory: false
    });

    ul.append(li);
  });
}

function setupFavoriteChangeListener() {
  try {
    document.addEventListener('favoriteChanged', () => {
      const $input = Elements.getInput();
      const hasQuery = typeof $input.val === 'function' && ($input.val()?.trim()?.length || 0) >= 3;
      if (!hasQuery) {
        renderSearchHistory();
      }
    });
  } catch (e) {
  }
}

function renderSuggestions(suggestions) {
  const ul = Elements.getUl();
  const header = Elements.getHeader();
  const empty = Elements.getEmptyMessage();

  ul.empty().show();
  header.hide();
  empty.hide();

  let index = 0;

  suggestions.forEach(({ places, type }) => {
    if (!places.length) return;

    ul.append($('<p>').text(titleByType[type]));

    places.forEach((place) => {
      index++;
      const meta = buildCityMeta(place, type);
      const cityData = LocalStorageHelper.mapCityData(place);
      const favButton = createFavoriteButton(cityData, type);
      const genericData = getGenericData('search')
      const data = {
        ...genericData,
        [keyByType[type]]: cityData
      }

      const a = $('<a>').attr('href', meta.href).on('click', () => {
        SearchedStorage.append(data, 10, 'cid', keyByType[type]);
      });

      const li = createListItem({
        label: meta.label,
        href: meta.href,
        favButton,
        linkElement: a,
        index,
        cityCid: cityData.cid,
      });

      ul.append(li);
    });
  });

  if (Elements.getIsDesktop()) ul.css('padding-top', '8px');
}

function buildCityMeta(place, type) {
  const name = place[keyByType[type]];

  const uf = place.uf === 'ND' && place.ac ? place.ac : place.uf;
  const label = `${name} - ${uf}`;
  const slug = slugify(String(name)).replaceAll("-", "").toLowerCase();
  const href = `/previsao-do-tempo/${pathByType[type]}/${place[idKeyByType[type]]}/${slug}-${uf.toLowerCase()}`;
  return { name, uf, label, href };
}

export function toggleFavorite(city, elementId, type) {
  const favorites = FavoriteStorage.get();

  const isCurrentlyFavorited = favorites.some(p => p?.city?.cid === city.cid);
  const willBeFavorited = !isCurrentlyFavorited;

  const genericData = getGenericData('favorite');

  const dataToSave = {
    ...genericData,
    city: city
  };

  const dataLayerCityData = {
    type: type,
    el_id: city.cid,
    el_name: city.label,
  }

  if (isCurrentlyFavorited) {
    FavoriteStorage.remove({ cid: city.cid }, 'cid', 'city');

    pushOnDataLayer('remove_favorite', elementId, dataLayerCityData);
  } else {
    FavoriteStorage.append(dataToSave, 50, 'cid', 'city');

    pushOnDataLayer('add_favorite', elementId, dataLayerCityData);
  }

  const event = new CustomEvent('favoriteChanged', {
    detail: {
      city: city,
      isFavorited: willBeFavorited
    }
  });

  document.dispatchEvent(event);
}

function createFavoriteButton(city, type) {
  const button = $('<button type="button" class="historyFavButton"></button>');
  const icon = $('<img>').attr('alt', 'Ícone de favorito');
  button.append(icon);

  button.attr('data-cid', city.cid);

  function updateVisual(isFavorited) {
    const iconName = isFavorited ? 'star-filled' : 'star-empty';
    const title = isFavorited ? 'Remover dos favoritos' : 'Favoritar cidade';
    icon.attr('src', `/dist/images/v2/svg/${iconName}.svg`);
    button.attr('title', title);
  }

  updateVisual(FavoriteStorage.get().some(p => p.city.cid === city.cid));

  button.on('click', (e) => {
    e.stopPropagation();
    toggleFavorite(city, 'Menu_MainSearch_Button_Star', type);
  });

  document.addEventListener('favoriteChanged', (event) => {
    if (event.detail.city.cid === city.cid) {
      updateVisual(event.detail.isFavorited);
    }
  });

  return button;
}

function pushOnDataLayer(eventName, id, additionalData = {}) {
  window.dataLayer = window.dataLayer || [];

  window.dataLayer.push({
    event: eventName,
    id: id,
    ...additionalData
  })
}

function createListItem({
  label,
  href,
  icon = null,
  favButton = null,
  linkElement = null,
  index = 0,
  cityCid,
  isHistory = false
}) {
  const li = $('<li class="autocomplete-item" role="option" aria-selected="false"></li>');
  const wrapper = $('<div class="autocomplete-content"></div>');

  const eventIndex = String(index).padStart(2, '0');
  const getIsItemFavorited = () => FavoriteStorage.get().some(p => p?.city?.cid === cityCid);
  let dataId = '';
  
  if (isHistory && getIsItemFavorited()) {
    dataId = `Menu_MainSearch_FavoriteItem_RecentLink-${eventIndex}`;
  } else if (isHistory) {
    dataId = `Menu_MainSearch_RecentItem-${eventIndex}`;
  } else if (getIsItemFavorited()) {
    dataId = `Menu_MainSearch_FavoriteItem_NavLink-${eventIndex}`;
  } else {
    dataId = `Menu_MainSearch_Item_NavLink-${eventIndex}`;
  }

  const a = linkElement?.attr('data-id', dataId) || $('<a></a>').attr('href', href).attr('data-id', dataId);

  a.append($('<span></span>').text(label));
  if (icon) a.prepend(icon);

  const contentWrapper = $('<div></div>').append(a);
  wrapper.append(contentWrapper);
  if (favButton) wrapper.append(favButton);
  li.append(wrapper);
  return li;
}

function debounce(fn, delay) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => fn.apply(this, args), delay);
  };
}

function setupDesktopClickListener() {
  const input = Elements.desktopInput;
  const container = Elements.desktopAutocomplete;

  input.on('click', (e) => {
    e.stopPropagation();
    container.css('display', 'flex');
    input.attr('aria-expanded', 'true');
    pushOnDataLayer('show_element', 'Menu_MainSearch__');
  });
}

function setupClickOutsideListener() {
  $(document).on('click', (e) => {
    const container = Elements.desktopAutocomplete;
    const input = Elements.desktopInput;
    const mobileWrapper = $('[data-id="mobile-search"]');
    const mobileToggle = Elements.mobileSearchButton;
    const mobileContainer = Elements.mobileAutocomplete;

    if (!container.is(e.target) && container.has(e.target).length === 0 && !input.is(e.target)) {
      container.hide();
      input.attr('aria-expanded', 'false');
    }

    const clickedInsideMobile = mobileContainer.is(e.target) || mobileContainer.has(e.target).length > 0;
    const clickedToggle = mobileToggle.is(e.target) || mobileToggle.has(e.target).length > 0;
    const isMobileVisible = mobileContainer.is(':visible');
    if (!clickedInsideMobile && !clickedToggle && isMobileVisible) {
      if (mobileWrapper.length && mobileWrapper.is(':visible')) {
        mobileWrapper.stop(true, true).slideUp('fast');
      }
      mobileContainer.hide();
      Elements.mobileSearchButton.attr('aria-expanded', 'false');
      Elements.mobileInput.attr('aria-expanded', 'false');
      pushOnDataLayer('close_element', 'Menu_MainSearch');
    }
  });
}

function setupUseLocationButtonListener() {
  const $targets = Elements.myLocationButton.add(Elements.mobileLocationButton);

  try {
    $targets.each(function () {
      const $btn = $(this);
      if (!$btn.data('original-html')) {
        $btn.data('original-html', $btn.html());
      }
    });
  } catch (e) {}

  const callback = async (e) => {
    pushOnDataLayer('click_button', 'Menu_MainSearch_Button_UseLocation');

    const $btn = $(e.currentTarget);

    try {
      if ('permissions' in navigator) {
        const status = await navigator.permissions.query({ name: 'geolocation' });
        if (status?.state === 'denied') {
          geolocationInstructionsModal.open();
          return;
        }
      }
    } catch (err) {}

    if ('geolocation' in navigator) {
      try {
        $btn.empty().attr('disabled', 'true').append('<div class="loading"></div>');
      } catch (err) {}

      navigator.geolocation.getCurrentPosition(
        (pos) => {
          handleUserGeolocation(pos);
        },
        () => {
          try {
            const original = $btn.data('original-html');
            if (original) {
              $btn.removeAttr('disabled').html(original);
            }
          } catch (err) {}
          geolocationInstructionsModal.open();
        },
        { enableHighAccuracy: true, maximumAge: 3000 }
      );
    } else {
      geolocationInstructionsModal.open();
    }
  };

  $targets.off('click').on('click', callback);
}

function setupCloseButtons() {
  const onClose = () => {
    Elements.desktopAutocomplete.hide();
    Elements.mobileAutocomplete.hide();

    const mobileWrapper = $('[data-id="mobile-search"]');
    if (mobileWrapper.length && mobileWrapper.is(':visible')) {
      mobileWrapper.slideUp('fast');
    }

    if (!Elements.getIsDesktop()) {
      Elements.mobileSearchButton.attr('aria-expanded', 'false');
    }
    Elements.getInput().attr('aria-expanded', 'false');
    pushOnDataLayer('close_element', 'Menu_MainSearch');
  };

  Elements.desktopCloseButton.off('click').on('click', onClose);
  Elements.mobileCloseButton.off('click').on('click', onClose);
}

async function handleUserGeolocation(geolocationPosition) {
  const { coords } = geolocationPosition;

  try {
    const requestedCity = await $.ajax({
      url: '/json/minha-localizacao',
      type: 'POST',
      dataType: 'json',
      cache: true,
      context: this,
      data: { latitude: coords.latitude, longitude: coords.longitude },
      contentType: 'application/x-www-form-urlencoded'
    });

    const { city, uf, idcity } = requestedCity?.data?.[0] || {};
    if (city && uf && idcity) {
      const slug = slugify(String(city)).replaceAll('-', '').toLowerCase();
      const href = `/previsao-do-tempo/cidade/${idcity}/${slug}-${uf.toLowerCase()}`;
      window.location = href;
      return;
    }
  } catch (e) {}

  redirectToSaoPaulo();
}

function redirectToSaoPaulo() {
  window.location = '/previsao-do-tempo/cidade/558/saopaulo-sp';
}

function setupClearHistoryButtonListener() {
  const onClear = () => {
    SearchedStorage.clear();

    const ul = Elements.getUl();
    const header = Elements.getHeader();
    const empty = Elements.getEmptyMessage();

    ul.hide().empty();
    header.hide();
    empty.show();

    Elements.mobileClearButton.hide();
    Elements.desktopClearButton.hide();

    Elements.getInput().trigger('focus');
  };

  Elements.mobileClearButton.off('click').on('click', onClear);
  Elements.desktopClearButton.off('click').on('click', onClear);
}

function initializeMyLocationLabel() {
  try {
    if (!('permissions' in navigator)) return;
    navigator.permissions.query({ name: 'geolocation' }).then((status) => {
      if (status.state !== 'granted') return;
      if ('geolocation' in navigator) {
        navigator.geolocation.getCurrentPosition(async (pos) => {
          try {
            const requestedCity = await $.ajax({
              url: '/json/minha-localizacao',
              type: 'POST',
              dataType: 'json',
              cache: true,
              context: this,
              data: { latitude: pos.coords.latitude, longitude: pos.coords.longitude },
              contentType: 'application/x-www-form-urlencoded'
            });
            const cityData = requestedCity?.data?.[0];
            if (!cityData) return;
            const uf = cityData.uf?.toUpperCase?.() || '';
            const label = `${cityData.city} - ${uf}`;
            Elements.myLocationButton.find('span').text(label);
            Elements.mobileLocationButton.find('span').text(label);
          } catch (e) {}
        });
      }
    });
  } catch (e) {}
}

function openSearchWhenComingFromPush() {
  if (!cameFromPushSource()) return;

  const wrapper = $('[data-id="mobile-search"]');
  if (wrapper.length) {
    wrapper.show();
  }

  const isDesktop = Elements.getIsDesktop();
  const container = isDesktop ? Elements.desktopAutocomplete : Elements.mobileAutocomplete;

  container.css('display', 'flex');
  Elements.getInput().attr('aria-expanded', 'true');

  if (!isDesktop) {
    Elements.mobileSearchButton.attr('aria-expanded', 'true');
  }

  setTimeout(() => {
    Elements.getInput().trigger('focus');
  }, 0);

  pushOnDataLayer('open_element', 'Menu_MainSearch');
}

function cameFromPushSource() {
  try {
    const params = new URLSearchParams(window.location.search || '');
    const normalized = (val) => (val || '').toString().toLowerCase();
    const pushWords = ['push', 'pushnews', 'pushnotification', 'push_notification'];

    const hasPushFlag = ['push', 'frompush', 'pushnotification', 'push_notification'].some((key) => {
      if (!params.has(key)) return false;
      const value = normalized(params.get(key));
      if (!value) return true;
      return value === '1' || value === 'true' || value === 'yes' || pushWords.some((word) => value.includes(word));
    });

    const utmSource = normalized(params.get('utm_source'));
    const utmMedium = normalized(params.get('utm_medium'));
    const utmCampaign = normalized(params.get('utm_campaign'));
    const hasPushUtm = [utmSource, utmMedium, utmCampaign].some((value) => pushWords.some((word) => value.includes(word)));

    return hasPushFlag || hasPushUtm;
  } catch (e) {
    return false;
  }
}
